export default "__VITE_ASSET__Bgq3Extp__"